import React, { useState } from 'react';
import { Table, TableBody, TableHead, Paper, Grid, TextField, TableRow, TableCell, IconButton, Button, Tooltip, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withRouter } from 'react-router'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import { DropzoneArea } from 'material-ui-dropzone';
import MomentUtils from '@date-io/moment';
import { backendDateFormat, displayDateFormatShort } from '../../../constants';
import { CkEditorText } from '../../../shared_elements';
import { checkApiStatus, onCheckFormPermission } from '../../../utils_v2';
import { globalDeleteService } from '../../../globalServices';
import { trackActivity } from '../../../utils/mixpanel';
import { DeletePopUp } from '../../../shared_elements';
import { assetTypeId } from '../../../constants';

function ConclusionV2({ params, data, setData, onFieldChange, callthisapi, getResponseBack, currentFormDetail, setLoading, isLoading, formSave, setFormSave, digitalSigntureUpload }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [deleteModal, setDeleteModal] = useState({ modal: false, data: null })
    const [modal, setModal] = useState({ open: false, data: null })
    const [files, setFiles] = React.useState([]);
    const [delteSignature, setDelteSignature] = useState({ modal: false, data: null, id: null })
    const [previewFile, setPreviewFile] = useState({ modal: false, data: null, singlepreview: null })
    const handleFileUpload = () => {
        digitalSigntureUpload(files, modal?.data)
        setModal({ open: false, data: null })
    };
    const handleDropzoneChange = (uploadedFiles) => {
        setFiles(uploadedFiles);
    };

    const techAction = data?.powerplant_fleet_tech_summaries && data?.powerplant_fleet_tech_summaries?.tech_open_action?.filter(item => item?.id)?.length === data?.powerplant_fleet_tech_summaries?.tech_open_action?.length

    const techActionCall = (modeTye, row, extra) => {
        if (modeTye === 'add') {
            setData(prev => (
                {
                    ...prev,
                    powerplant_fleet_tech_summaries: {
                        ...prev.powerplant_fleet_tech_summaries,
                        tech_open_action: [
                            ...prev.powerplant_fleet_tech_summaries?.tech_open_action,
                            { description: null, assigned_responsibility: null, selected_by: null, deltedId: Math.floor(Math.random() * 90) + 10 }]
                    }
                }

            ));
        } else if (row?.id) {
            setLoading(true)
            globalDeleteService(`/technical/t015/basic-inspection/${row?.id}/delete/?module=action`)
                .then(response => {
                    if (checkApiStatus(response)) {
                        getResponseBack()
                        setLoading(false)
                        setDeleteModal({ modal: false, data: null })
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        trackActivity('Project Management', {
                            event_type: 'Technical Open Actions:',
                            page_title: 'T015 Form',
                            deleted_id: row?.id || '',
                            success_msg: response?.data?.message
                        });
                    } else {
                        getResponseBack()
                        setLoading(false)
                        setDeleteModal({ modal: false, data: null })
                        enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        trackActivity('Project Management', {
                            event_type: 'Technical Open Actions:',
                            page_title: 'T015 Form',
                            deleted_id: row?.id || '',
                            success_msg: response?.data?.message
                        });
                    }
                });
        } else {
            setData(prev => (
                {
                    ...(prev),
                    powerplant_fleet_tech_summaries: {
                        ...prev.powerplant_fleet_tech_summaries,
                        tech_open_action:
                            [...data?.powerplant_fleet_tech_summaries.tech_open_action]?.filter(item => item?.deltedId !== extra?.deltedId)
                    }
                }

            ));
        }

    }

    const onDeletePicture = () => {
        setLoading(true);
        globalDeleteService(`technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/tct015basicinpection/${data?.id}/attachment/${assetTypeId[params?.type]}/${delteSignature?.id}`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    setDelteSignature({ modal: false, data: null, id: null });
                    getResponseBack()
                    trackActivity('Project Management', {
                        event_type: delteSignature?.data === 1 ? 'Inspector Digital Signature' : 'Reviewer Digital Signature',
                        page_title: 'T015 Form MLI',
                        workOrderSlug: params?.workOrderSlug ? params.workOrderSlug : '',
                        success_msg: 'Inspector Digital Signature delete success'
                    })
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    setDelteSignature({ modal: false, data: null });
                    getResponseBack()
                    trackActivity('Project Management', {
                        event_type: delteSignature?.data === 1 ? 'Inspector Digital Signature' : 'Reviewer Digital Signature',
                        page_title: 'T015 Form MLI',
                        workOrderSlug: params?.workOrderSlug ? params.workOrderSlug : '',
                        error_msg: 'Inspector Digital Signature delete failed'
                    })
                }
            })
    }

    return (
        <section className='form-t015'>
            <Paper square style={{ padding: '10px', marginBottom: "5px" }} elevation={8}>
                <ul className='list-inline'>
                    <li className='list-inline-item'> <h4>5. Technical Summary : </h4></li>
                    <li className='list-inline-item' style={{ float: 'right' }}>
                        {!(formSave?.type === 'tech_summary' && formSave?.open) && (
                            <Tooltip title="Edit" placement="top">
                                <IconButton disabled={!onCheckFormPermission(currentFormDetail) || formSave?.isdisabled} style={{ cursor: 'pointer' }} color="primary" size="small" onClick={() => setFormSave({ open: true, type: 'tech_summary', isdisabled: true })} > <EditIcon /> </IconButton>
                            </Tooltip>
                        )}
                        {formSave?.type === 'tech_summary' && (
                            <>
                                <Tooltip title="Cancel" placement="top">
                                    <Button style={{ marginInline: '5px' }} variant="outlined" color="primary" onClick={() => { getResponseBack(); setFormSave({ open: false, type: '', isdisabled: false }); }} size="small" > Cancel </Button>
                                </Tooltip>
                                <Tooltip title="Save" placement="top">
                                    <Button variant="contained" color="primary" onClick={() => { callthisapi('', data); setFormSave({ open: false, type: '', isdisabled: false }); }} size="small" > Save </Button>
                                </Tooltip>
                            </>
                        )}
                    </li>
                </ul>
                <h6 style={{ margin: '10px 0px 0px' }}> 5.1 Technical Open Actions :</h6>
                <ul className='list-inline' >
                    <li className="list-inline-item">
                        <p style={{ margin: '20px 0px 0px' }}>The items below require follow up actions after the Mid-Lease Inspection visit</p>
                    </li>
                    <li className="list-inline-item" style={{ float: 'right' }}>
                        <Button disabled={formSave?.type !== 'tech_summary' || !onCheckFormPermission(currentFormDetail)} onClick={() => techActionCall("add")} color="primary" variant="contained" size="small" style={{ margin: '5px' }} >+ ADD</Button>
                    </li>
                </ul>
                <Table className='mui-table-format-t015'>
                    <TableHead className='table-align-head'>
                        <TableRow >
                            <TableCell> <h6 >SR No</h6> </TableCell>
                            <TableCell> <h6>Description</h6> </TableCell>
                            <TableCell> <h6>Responsibility</h6> </TableCell>
                            <TableCell> <h6>By</h6> </TableCell>
                            <TableCell> <h6>Action</h6> </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.powerplant_fleet_tech_summaries?.tech_open_action?.map((item, index) => (
                            <TableRow>
                                <TableCell align='center'>{index + 1}</TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'tech_summary'}
                                        variant='outlined'
                                        margin='normal'
                                        fullWidth
                                        id='description'
                                        inputProps={{ maxLength: 50 }}
                                        InputLabelProps={{ shrink: true }}
                                        value={item?.description || ''}
                                        onChange={(e) => onFieldChange(e, "description", e.target.value, 'powerplant_fleet_tech_summaries', index, '', 'tech_open_action')}
                                        placeholder="Enter."
                                    />
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <Autocomplete
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'tech_summary'}
                                        options={['SAEL', 'LESSEE','OPERATOR']}
                                        getOptionLabel={option => option}
                                        id="assigned_responsibility"
                                        value={item?.assigned_responsibility || null}
                                        onChange={(e, value) => onFieldChange(e, "assigned_responsibility", value, 'powerplant_fleet_tech_summaries', index, '', 'tech_open_action')}
                                        renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                                    />
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <Autocomplete
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'tech_summary'}
                                        options={['Redelivery', 'Next MLI', 'ASAP']}
                                        getOptionLabel={option => option}
                                        id="selected_by"
                                        value={item?.selected_by || null}
                                        onChange={(e, value) => onFieldChange(e, "selected_by", value, 'powerplant_fleet_tech_summaries', index, '', 'tech_open_action')}
                                        renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                                    />
                                </TableCell>
                                <TableCell align='center'>
                                    <Tooltip title='Delete' arrow>
                                        <IconButton disabled={formSave?.type !== 'tech_summary' || !onCheckFormPermission(currentFormDetail)} color='secondary' >
                                            <DeleteOutlinedIcon onClick={() => { item?.id ? setDeleteModal({ modal: true, data: item }) : techActionCall('', '', item) }} />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>

                        ))
                        }

                    </TableBody>
                </Table>
                <h6 style={{ margin: '25px 0px 10px' }}>5.2 Additional Comments / Highlights / Concerns : </h6>
                <Grid item xs={12} md={12} sm={12}>
                    <div>
                        <CkEditorText
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'tech_summary'}
                            htmlData={data?.powerplant_fleet_tech_summaries?.additional_comments || ''}
                            onChangeData={(value) => setData({
                                ...data,
                                powerplant_fleet_tech_summaries: {
                                    ...data.powerplant_fleet_tech_summaries,
                                    additional_comments: value
                                }
                            })}
                        />
                    </div>
                </Grid>
                <h5 style={{ margin: '15px 0px 10px' }}> Report Details :</h5>
                <ul className='list-inline' >
                    <li className="list-inline-item">
                        <h6 style={{ margin: '10px 0px 10px' }}> Report Completed By :</h6>
                    </li>
                    <li className="list-inline-item" style={{ display: 'inline-flex' }}>
                        <TextField
                            style={{ width: '250px', marginLeft: '20px' }}
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'tech_summary'}
                            variant='outlined'
                            margin='normal'
                            id='report_completed_by'
                            inputProps={{ maxLength: 100 }}
                            InputLabelProps={{ shrink: true }}
                            value={data?.powerplant_fleet_tech_summaries?.report_completed_by || ''}
                            onChange={(e) => onFieldChange(e, "report_completed_by", e.target.value, 'powerplant_fleet_tech_summaries')}
                            placeholder="Enter."
                        />
                    </li>
                </ul>
                <ul className='list-inline' >
                    <li className="list-inline-item">
                        <h6 style={{ margin: '15px 0px 15px' }}> Report Completion Date :  </h6>
                    </li>
                    <li className="list-inline-item" style={{ display: 'inline-flex' }}>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <KeyboardDatePicker
                                disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'tech_summary'}
                                margin="normal"
                                id="report_completion_date"
                                format={displayDateFormatShort}
                                style={{ width: "250px", marginLeft: '2px' }}
                                InputLabelProps={{ shrink: true }}
                                value={data?.powerplant_fleet_tech_summaries?.report_completion_date || null}
                                onChange={(date) => onFieldChange('', 'report_completion_date', date ? moment(date).format(backendDateFormat) : null, 'powerplant_fleet_tech_summaries', '', 'date')}
                                inputVariant='outlined'
                            />
                        </MuiPickersUtilsProvider>
                    </li>
                </ul>
                <ul className='list-inline' >
                    <li className="list-inline-item">
                        <h6 style={{ margin: '10px 0px 10px' }}> Report Reviewed By :</h6>
                    </li>
                    <li className="list-inline-item" style={{ display: 'inline-flex' }}>
                        <TextField
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'tech_summary'}
                            variant='outlined'
                            margin='normal'
                            style={{ width: '250px', marginLeft: '31px' }}
                            id='report_reviewed_by'
                            inputProps={{ maxLength: 100 }}
                            InputLabelProps={{ shrink: true }}
                            value={data?.powerplant_fleet_tech_summaries?.report_reviewed_by || ''}
                            onChange={(e) => onFieldChange(e, "report_reviewed_by", e.target.value, 'powerplant_fleet_tech_summaries')}
                            placeholder="Enter."
                        />
                    </li>
                </ul>
                <ul className='list-inline' >
                    <li className="list-inline-item">
                        <h6 style={{ margin: '15px 0px 15px' }}>  Review Completion Date :  </h6>
                    </li>
                    <li className="list-inline-item" style={{ display: 'inline-flex' }}>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <KeyboardDatePicker
                                disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'tech_summary'}
                                margin="normal"
                                id="review_completion_date"
                                format={displayDateFormatShort}
                                style={{ width: "250px" }}
                                InputLabelProps={{ shrink: true }}
                                value={data?.powerplant_fleet_tech_summaries?.review_completion_date || null}
                                onChange={(date) => onFieldChange('', 'review_completion_date', date ? moment(date).format(backendDateFormat) : null, 'powerplant_fleet_tech_summaries', '', 'date')}
                                inputVariant='outlined'
                            />
                        </MuiPickersUtilsProvider>
                    </li>
                </ul>
                <h6 style={{ margin: '10px 0px 10px' }}> 5.3 Reviewer Additional Comments / Highlights / Concerns : </h6>
                <Grid item xs={12} md={12} sm={12}>
                    <div>
                        <CkEditorText
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'tech_summary'}
                            htmlData={data?.powerplant_fleet_tech_summaries?.reviewer_comments || ''}
                            onChangeData={(value) => setData({
                                ...data,
                                powerplant_fleet_tech_summaries: {
                                    ...data.powerplant_fleet_tech_summaries,
                                    reviewer_comments: value
                                }
                            })}
                        />
                    </div>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={4} sm={4}>
                        <h5 style={{ margin: '5px 0px 10px' }}>Inspector Digital Signature:</h5>
                        {data?.inspector_digital_signature?.map((items, index) => (
                            <div>
                                <Paper square elevation={1} style={{ height: '40px', margin: '0px 10px 0px' }}>
                                    <div className="dropped-picture-cta" style={{ background: 'rgba(255, 255, 255, 0.5) ' }}>
                                        {!onCheckFormPermission(currentFormDetail) ? null : <Tooltip title='Delete' >
                                            <IconButton disabled={formSave?.isdisabled} onClick={() => setDelteSignature({ modal: true, data: 1, id: items?.id })} style={{ float: 'right' }}  >
                                                <DeleteOutlineIcon color={formSave?.isdisabled ? '' : "secondary"} fontSize='small' style={{ cursor: 'pointer' }} />
                                            </IconButton>
                                        </Tooltip>}
                                    </div>
                                </Paper>
                                <div className="dropped-pic-card" style={{ backgroundSize: 'cover', backgroundImage: "url(" + items?.url + ")", width: 'auto', height: '208px', border: 'groove 1px', borderColor: 'lightgray', margin: '0px 10px 10px 10px', padding: '2px' }}>
                                </div>
                            </div>
                        )
                        )}
                    </Grid>
                    <Grid item xs={12} md={2} sm={2} style={{ float: 'right', marginTop: '5px' }}>
                        <Button onClick={() => setModal({ open: true, data: 1 })} disabled={data?.inspector_digital_signature?.length || formSave?.isdisabled} variant='outlined' color='primary'>Upload Signature</Button>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={4} sm={4}>
                        <h5 style={{ margin: '5px 0px 10px' }}>Reviewer Digital Signature:</h5>
                        {data?.reviewer_digital_signature?.map((items, index) => (
                            <div>
                                <Paper square elevation={1} style={{ height: '40px', margin: '0px 10px 0px' }}>
                                    <div className="dropped-picture-cta" style={{ background: 'rgba(255, 255, 255, 0.5) ' }}>
                                        {!onCheckFormPermission(currentFormDetail) ? null : <Tooltip title='Delete' >
                                            <IconButton disabled={formSave?.isdisabled} onClick={() => setDelteSignature({ modal: true, data: 2, id: items?.id })} style={{ float: 'right' }} >
                                                <DeleteOutlineIcon color={formSave?.isdisabled ? '' : "secondary"} fontSize='small' style={{ cursor: 'pointer' }} />
                                            </IconButton>
                                        </Tooltip>}
                                    </div>
                                </Paper>
                                <div className="dropped-pic-card" style={{ backgroundSize: 'cover', backgroundImage: "url(" + items?.url + ")", width: 'auto', height: '208px', border: 'groove 1px', borderColor: 'lightgray', margin: '0px 10px 10px 10px', padding: '2px' }}>
                                </div>
                            </div>
                        )
                        )}
                    </Grid>
                    <Grid item xs={12} md={2} sm={2} style={{ float: 'right', marginTop: '5px' }}>
                        <Button onClick={() => setModal({ open: true, data: 2 })} disabled={data?.reviewer_digital_signature?.length || formSave?.isdisabled} variant='outlined' color='primary'>Upload Signature</Button>
                    </Grid>
                </Grid>
            </Paper>
            {deleteModal?.modal ?
                <DeletePopUp
                    modal={deleteModal.modal}
                    toggleModalFn={() => setDeleteModal({ modal: false, data: null })}
                    title="Technical Open Actions"
                    content={<h4>Are you sure you want to delete?</h4>}
                    deleteRecordFn={() => techActionCall('', deleteModal?.data)}
                /> : null
            }
            {
                modal?.open ?
                    <Dialog
                        open={true}
                        onClose={() => setModal({ open: false, data: null })}
                    >
                        <DialogTitle id="scroll-dialog-title">
                            Upload Signature
                        </DialogTitle>
                        <DialogContent dividers={true}>
                            <div style={{ width: '380px' }}>
                                <DropzoneArea
                                    filesLimit={1}
                                    maxFileSize={104857600}
                                    showPreviewsInDropzone={false}
                                    useChipsForPreview={true}
                                    acceptedFiles={['.png, .jpg, .jpeg, .heif, .heic']}
                                    showPreviews={true}
                                    dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                                    dropzoneClass="drag-drop-cnt"
                                    maxWidth="sm"
                                    showAlerts={['info', 'error']}
                                    alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                    clearOnUnmount={true}
                                    onChange={handleDropzoneChange}
                                    previewChipProps={{
                                        onClick: (event) => {
                                            setPreviewFile({ modal: true, data: [files.find(item => item?.path === event?.target.textContent)], singlepreview: true })
                                        }
                                    }}
                                />
                            </div>
                            <span className='attachment-note'> Note :File upload limit is 1 in single time.</span>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setModal({ open: false, data: null })} color="primary" size='small' variant='outlined'>Close</Button>
                            <Button onClick={handleFileUpload} disabled={files?.length > 0 ? false : true} color="primary" size='small' variant='contained'>Proceed</Button>
                        </DialogActions>
                    </Dialog> : null}
            {
                delteSignature?.modal ?
                    <DeletePopUp
                        modal={delteSignature?.modal}
                        title={delteSignature?.data === 1 ? 'Inspector Digital Signature' : 'Reviewer Digital Signature'}
                        content={`Are you sure, you want to Delete?`}
                        toggleModalFn={() => setDelteSignature({ modal: false, data: null, id: null })}
                        deleteRecordFn={onDeletePicture}
                    /> : null
            }
            {
                previewFile?.modal ?
                    <Dialog
                        open={previewFile?.modal}
                        onClose={() => setPreviewFile({ modal: false, data: null })}
                        style={{ height: "100vh" }}
                        fullWidth
                        maxWidth="lg"
                    >
                        <DialogTitle>
                            Image Preview
                        </DialogTitle>
                        <DialogContent dividers>
                            {previewFile?.singlepreview && previewFile?.data?.map((file, index) => (
                                <div key={index}>
                                    {
                                        file.type.startsWith('image/') && (
                                            <img src={URL.createObjectURL(file)} alt={file.name} style={{ width: '100%', height: '100vh' }} />
                                        )
                                    }
                                </div>
                            ))
                            }
                        </DialogContent>
                        <DialogActions>
                            <Button color="primary" size='small' variant="outlined" onClick={() => setPreviewFile({ modal: false, data: null })}>Close</Button>
                        </DialogActions>
                    </Dialog> : null
            }

        </section>
    );
}
export default withRouter(ConclusionV2)